import Masonry from 'masonry-layout';
var imagesLoaded = require('imagesloaded');
var jQueryBridget = require('jquery-bridget');
import GLightbox from 'glightbox';

const brickGalerie = {
    init: function () {
        let self = this;
        jQueryBridget('masonry', Masonry, $);
        
        if ($('.brick-galerie .grid-item').length) {
            if (window.innerWidth > 480) {
                self.initGalerieGrid();
            }
        }
    },

    initGalerieGrid: function () {
        let picturesMsnry = $( '.grid-wrapper').masonry( {
            itemSelector: '.grid-item',
            columnWidth: '.grid-item',
            percentPosition: true,
        });
        picturesMsnry.imagesLoaded().progress( function() {
            picturesMsnry.masonry('layout');
        });

        setTimeout(function() {
            const lightbox = GLightbox();
        }, 100)
    }
}

export { brickGalerie };